<template>
  <div class="product__links">
    <AProductSample 
      :qty="1"
      :product="product" 
      :disabled="false"
      label="Gratis Muster anfordern"
      class="product-sample btn btn-xs"
    />
    <AProductRoomDesigner
      :product="product"
      class="btn btn-xs"
    />
    <a
      href="#product-datasheet"
      class="product-link-document btn btn-xs"
    >Datenblatt ansehen</a>
  </div>
</template>

<script>
import AProductSample from 'theme/components/atoms/a-product-sample';
import AProductRoomDesigner from 'theme/components/atoms/a-product-room-designer';
import { scrollTo } from 'theme/helpers/custom';
import {
  mapMobileObserver,
  unMapMobileObserver
} from "@storefront-ui/vue/src/utilities/mobile-observer";

export default {
  name: 'MProductLinks',
  components: {
    AProductSample,
    AProductRoomDesigner
  },
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
  },
  computed: {
    ...mapMobileObserver()
  },
  beforeDestroy () {
    unMapMobileObserver();
  }
};
</script>

<style lang="scss" scoped>
</style>
